import { render, staticRenderFns } from "./MtdExpenseList.vue?vue&type=template&id=24f61158&"
import script from "./MtdExpenseList.vue?vue&type=script&lang=js&"
export * from "./MtdExpenseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports